import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease, delay }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <span className={`overline ${className}`}>{children}</span>
);

export const Section = ({ children, className = "", id }) => (
  <section id={id} className={`px-6 md:px-12 lg:px-20 ${className}`}>
    <div className="mx-auto max-w-[1400px]">{children}</div>
  </section>
);

const base = "inline-flex items-center gap-2 font-sans font-medium transition-all duration-300 group";

export const Button = ({ to, href, children, variant = "primary", onClick, className = "", type, testId, ...rest }) => {
  const styles = {
    primary: `${base} rounded-full bg-botanical text-ivory px-7 py-3.5 text-sm hover:bg-forest`,
    outline: `${base} rounded-full border border-botanical/40 text-botanical px-7 py-3.5 text-sm hover:bg-botanical hover:text-ivory`,
    ghost: `${base} text-botanical text-sm hover:opacity-70`,
    light: `${base} rounded-full bg-ivory text-botanical px-7 py-3.5 text-sm hover:bg-white`,
    dark: `${base} rounded-none bg-botanical text-ivory px-6 py-3 text-sm hover:bg-forest`,
  };
  const cls = `${styles[variant]} ${className}`;
  const inner = <>{children}<ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></>;
  if (to) return <Link to={to} data-testid={testId} className={cls} onClick={onClick}>{inner}</Link>;
  if (href) return <a href={href} target="_blank" rel="noreferrer" data-testid={testId} className={cls} onClick={onClick}>{inner}</a>;
  return <button type={type || "button"} data-testid={testId} className={cls} onClick={onClick} {...rest}>{inner}</button>;
};

export const KineticHeading = ({ lines, className = "" }) => (
  <h1 className={`display ${className}`}>
    {lines.map((line, i) => (
      <span key={i} className="reveal-mask">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.1, ease, delay: 0.15 + i * 0.14 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </h1>
);
